import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    searchBoxWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    linksWrapper: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0 10px;
        `,
    },
    logoWrapper: {
        css: css`
            text-align: left;
            margin: 0 24px 0 0px;
            flex-grow: 5;
            & [class^="StyledButton"],
            & [class^="StyledButton"] > span {
                display: block;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin: 0;
                        `,
                        null,
                        css`
                            flex-grow: 11;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            .hidden-md-img {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: block;
                            `,

                            css`
                                display: block;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
            img {
                height: 78px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                height: 42px;
                                width: auto;
                                margin: 0;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    searchBoxWrapper: {
        css: css`
            flex-grow: 4;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    linksWrapper: {
        css: css`
            flex-grow: 3;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-end;
            font-family: FrutigerCn;
            > :first-child {
                [class^="TypographyStyle"] {
                    [class^="TypographyStyle"] {
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        display: none;
                                    `,
                                    null,
                                    null,
                                ],
                                "max",
                            );
                        }}
                    }
                }
            }
            & div > a[class^="StyledButton"],
            & div span[class^="StyledButton"],
            & div nav > a[class^="StyledButton"] {
                font-family: FrutigerCn;
                padding: 8px;
                margin: 0 7px;
                width: 72px;
                height: 100px;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 40px;
                            `,
                            css`
                                width: 40px;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
                &:hover {
                    background: ${getColor("common.backgroundContrast")};
                    [class^="TypographyStyle"] {
                        color: ${getColor("primary")};
                        [data-test-selector="cartLinkQuantity"] {
                            color: #fff;
                        }
                    }
                }
                & [class^="TypographyStyle"] {
                    text-transform: uppercase;
                    font-size: 12px;
                    line-height: 20px;
                    margin-top: 5px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    margin-top: 0px;
                                `,
                                css`
                                    margin-top: 0px;
                                `,
                                css`
                                    margin-top: 0px;
                                `,
                                css`
                                    margin-top: 5px;
                                `,
                                css`
                                    margin-top: 5px;
                                `,
                            ],
                            "min",
                        );
                    }}
                    font-family: "FrutigerCn";
                    width: 100%;
                }
            }

            & div > a[class^="StyledButton"] {
                & span[class^="StyledButton"] {
                    margin: 0;
                    padding: 5px;
                    width: auto;
                }
            }
            & div > a[class^="StyledButton"] span[class^="IconWrapper"],
            & nav > [class^="StyledButton"] span[class^="IconWrapper"] {
                width: 47px;
                height: 40px;
                & svg {
                    width: 47px;
                    height: 40px;
                }
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            text-align: right;
            padding: 20px 45px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        css`
                            flex-grow: 8;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    linkListHidden: {
        below: "lg",
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...logoLinksSearchStyles.container} data-test-selector="test-overide">
        <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
            <Zone contentId={id} zoneName="Logo" fixed />
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.searchBoxWrapper}>
            <Zone contentId={id} zoneName="Search" fixed />
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.linksWrapper}>
            <Hidden below="lg">
                <Zone contentId={id} zoneName="headerIconLinks" />
            </Hidden>
            <StyledWrapper>
                <Zone contentId={id} zoneName="SignIn" />
            </StyledWrapper>
            <StyledWrapper>
                <Zone contentId={id} zoneName="Cart" />
            </StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
